export interface IBankIncomeTypeDatatable {
  id: string;
  name: string;
}

const columns = () => [
  {
    id: 'id',
    header: 'ID',
    accessorKey: 'id',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'name',
    header: 'Name',
    accessorKey: 'name',
    cell: (ctx: any) => ctx.getValue(),
  },
  // {
  //   id: 'action',
  //   header: 'Action',
  //   accessorKey: 'action',
  //   cell: (ctx: any) => {
  //     const row = ctx.row.origial;
  //     return (
  //       <CC.Box>
  //         <CustomButton onClick={() => handleEdit(row)}>Editer</CustomButton>

  //         {/* <CustomButton onClick={() => handleDel(row)} variant="ghost" ml="2">
  //           Supp
  //         </CustomButton> */}
  //       </CC.Box>
  //     );
  //   },
  // },
];

export const BankIncomeTypeDatatableMeta = {
  columns,
};
